import React from "react";

function FaulseIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2938_2488)">
        <path
          d="M11.5003 11.5003L6.50033 6.50033M6.50033 11.5003L11.5003 6.50033M17.3337 9.00033C17.3337 4.39783 13.6028 0.666992 9.00033 0.666992C4.39783 0.666992 0.666992 4.39783 0.666992 9.00033C0.666992 13.6028 4.39783 17.3337 9.00033 17.3337C13.6028 17.3337 17.3337 13.6028 17.3337 9.00033Z"
          stroke="#424242"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2938_2488">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default FaulseIcon;
